<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" v-if="mode === 'new' || mode === 'edit'">
            <validationObserver ref="addDataForm" tag="form">
              <form @submit.prevent="onSubmit" @reset.prevent="onConfirmReset">
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">ชื่อคุณสมบัติ</label>
                  <div class="col-lg-6">
                    <validationProvider
                      v-slot="{ errors }"
                      name="Thai Name"
                      :rules="{
                        dynamicRequired: ['กรุณาระบุข้อมูล'],
                        duplicateName: [
                          isValidate.display_name_th,
                          'ชื่อภาษาไทยซ้ำกับข้อมูลที่อยู่ในระบบ',
                        ],
                        validateThaiWithSpecialCharacters: true,
                      }"
                    >
                      <div class="input-group check-length">
                        <span class="input-group-append">
                          <span class="input-group-text">TH</span>
                        </span>
                        <input
                          id="input_displayname_th"
                          name="input_displayname_th"
                          type="text"
                          class="form-control"
                          placeholder="ระบุชื่อคุณสมบัติภาษาไทย"
                          v-model="model.display_name.th"
                          :class="{
                            'is-invalid': errors && errors.length,
                            'is-valid':
                              !(errors && errors.length) &&
                              model.display_name.th,
                          }"
                          v-on:keyup="onValidateDisplaynameTH($event)"
                        />
                        <span class="input-validate-length">
                          {{ model.display_name.th.length }}
                        </span>
                        <!-- <span class="input-group-append">
                          <span class="input-group-text"
                            >{{ model.display_name.th.length }}
                          </span>
                        </span> -->
                      </div>
                      <div
                        v-if="errors && errors.length"
                        class="validate-invalid"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2"></label>
                  <div class="col-lg-6">
                    <validationProvider
                      v-slot="{ errors }"
                      name="English Name"
                      :rules="{
                        dynamicRequired: ['กรุณาระบุข้อมูล'],
                        duplicateName: [
                          isValidate.display_name_en,
                          'ชื่อภาษาอังกฤษซ้ำกับข้อมูลที่อยู่ในระบบ',
                        ],
                        validateEngWithSpecialCharacters: true,
                      }"
                    >
                      <div class="input-group check-length">
                        <span class="input-group-append">
                          <span class="input-group-text">EN</span>
                        </span>
                        <input
                          id="input_displayname_en"
                          name="input_displayname_en"
                          type="text"
                          class="form-control"
                          placeholder="ระบุชื่อคุณสมบัติภาษาอังกฤษ"
                          v-model="model.display_name.en"
                          :class="{
                            'is-invalid': errors && errors.length,
                            'is-valid':
                              !(errors && errors.length) &&
                              model.display_name.en,
                          }"
                          v-on:keyup="onValidateDisplaynameEN($event)"
                        />
                        <span class="input-validate-length">
                          {{ model.display_name.en.length }}
                        </span>
                        <!-- <span class="input-group-append">
                          <span class="input-group-text"
                            >{{ model.display_name.en.length }}
                          </span>
                        </span> -->
                      </div>
                      <div
                        v-if="errors && errors.length"
                        class="validate-invalid"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4" v-if="mode === 'new'">
                  <label class="col-form-label col-lg-2">ประเภท</label>
                  <div class="col-lg-2">
                    <basic-select
                      :options="optionsType"
                      :reload="reloadTypeSelector"
                      :selected-option="{
                        text: model.type,
                        value: model.type + '_value',
                      }"
                      @select="onTypeSelector($event)"
                      placeholder="ระบุประเภท"
                    >
                    </basic-select>
                  </div>
                </div>
                <div class="form-group row mb-4" v-else>
                  <label class="col-form-label col-lg-2">ประเภท</label>
                  <div class="col-form-label col-lg-8">
                    <div class="row col-lg-12">
                      <span
                        class="label"
                        :class="'label-' + model.type.toString().toLowerCase()"
                        v-html="model.type"
                      ></span>
                    </div>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Collection</label>
                  <div class="col-lg-8" v-if="model.type !== 'FreeText'">
                    <validationProvider
                      v-slot="{ errors }"
                      name="Collection"
                      :rules="{
                        dynamicRequired: ['กรุณาระบุข้อมูล'],
                      }"
                    >
                      <div class="input-group check-length">
                        <input
                          id="input_collection"
                          name="input_collection"
                          type="text"
                          class="form-control"
                          v-model="model.collection"
                          :class="{
                            'is-invalid': errors && errors.length,
                            'is-valid':
                              !(errors && errors.length) && model.collection,
                          }"
                        />
                        <div class="inline-icon">
                          <i
                            class="
                      ml-2
                      mt-2
                      bx bx-info-circle
                      align-middle
                      absolute
                      text-grey
                      f-18
                    "
                            id="tooltip-collection"
                          />
                          <b-tooltip
                            target="tooltip-collection"
                            placement="right"
                            variant="info"
                            >ถ้า Type เป็น Database ให้ระบุชื่อให้ตรงกับ
                            Database</b-tooltip
                          >
                        </div>
                      </div>
                      <div
                        v-if="errors && errors.length"
                        class="validate-invalid"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                  <div class="col-lg-8" v-else>
                    <div class="input-group check-length">
                      <input
                        id="input_collection"
                        name="input_collection"
                        type="text"
                        class="form-control"
                        v-model="model.collection"
                      />
                      <div class="inline-icon">
                        <i
                          class="
                      ml-2
                      mt-2
                      bx bx-info-circle
                      align-middle
                      absolute
                      text-grey
                      f-18
                    "
                          id="tooltip-collection"
                        />
                        <b-tooltip
                          target="tooltip-collection"
                          placement="right"
                          variant="info"
                          >ถ้า Type เป็น Database ให้ระบุชื่อให้ตรงกับ
                          Database</b-tooltip
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Filter</label>
                  <div class="col-lg-8">
                    <div class="input-group check-length">
                      <input
                        id="input_filter"
                        name="input_filter"
                        type="text"
                        class="form-control"
                        v-model="model.filter"
                      />
                      <div class="inline-icon">
                        <i
                          class="
                      ml-2
                      mt-2
                      bx bx-info-circle
                      align-middle
                      absolute
                      text-grey
                      f-18
                    "
                          id="tooltip-filter"
                        />
                        <b-tooltip
                          target="tooltip-filter"
                          placement="right"
                          variant="info"
                          >เป็นส่วนของ where ใน query เช่น status = active
                          ใส่ในรูปแบบของ nosql</b-tooltip
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Projection</label>
                  <div class="col-lg-8">
                    <div class="input-group check-length">
                      <input
                        id="input_projection"
                        name="input_projection"
                        type="text"
                        class="form-control"
                        v-model="model.projection"
                      />
                      <div class="inline-icon">
                        <i
                          class="
                      ml-2
                      mt-2
                      bx bx-info-circle
                      align-middle
                      absolute
                      text-grey
                      f-18
                    "
                          id="tooltip-projection"
                        />
                        <b-tooltip
                          target="tooltip-projection"
                          placement="right"
                          variant="info"
                          >เป็นส่วนของการเลือกส่วนการ display ที่หน้าจอ เช่น
                          select display_name th | display_name en
                          ใส่ในรูปแบบของ nosql</b-tooltip
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2"
                    >Default Attribute</label
                  >
                  <div class="col-form-label col-lg-8">
                    <div class="row col-lg-12">
                      <switches
                        v-model="model.is_default_attribute"
                        type-bold="true"
                        color="info"
                        class="switch-inner-label custom-switches switches-small"
                        text-enabled="Yes"
                        text-disabled="No"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">สถานะ</label>
                  <div class="col-lg-2">
                    <basic-select
                      :options="optionsStatus"
                      :reload="reloadStatusSelector"
                      :selected-option="{
                        text: model.status,
                        value: model.status,
                      }"
                      @select="onStatusSelector($event)"
                      placeholder="ระบุสถานะ"
                      v-bind:isError="isValidate.status"
                    >
                    </basic-select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="text-left">
                      <div class="button-items">
                        <button
                          type="button"
                          class="btn btn-light"
                          @click="onCancel()"
                        >
                          <i
                            class="bx bx-arrow-back font-size-16 align-middle mr-2"
                          ></i>
                          Back
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="text-right">
                      <div class="button-items">
                        <button type="submit" class="btn btn-primary">
                          <i class="bx bx-save" />Save
                        </button>
                        <button type="submit" class="btn btn-light">
                          <i class="bx bx-reset" />Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </validationObserver>
          </div>
          <div class="card-body" v-if="mode === 'view'">
            <div class="row mb-2">
              <div class="col-sm-8"></div>
              <div class="col-sm-4">
                <div class="text-sm-right">
                  <button
                    @click="changeMode('edit')"
                    type="button"
                    class="btn btn-warning waves-effect waves-light"
                  >
                    <i class="mdi mdi-pencil label-icon"></i>
                    Edit Attribute Mechanic
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">ชื่อ (ไทย)</label>
              <label class="col-form-label col-lg-8">
                <span class="badge-lang">TH</span>
                {{ model.display_name.th }}</label
              >
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">ชื่อ (อังกฤษ)</label>
              <label class="col-form-label col-lg-8">
                <span class="badge-lang">EN</span>
                {{ model.display_name.en }}</label
              >
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">ประเภท</label>
              <label class="col-form-label col-lg-8"
                ><span
                  class="label"
                  :class="'label-' + model.type.toString().toLowerCase()"
                  v-html="model.type"
                ></span
              ></label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">collection</label>
              <label class="col-form-label col-lg-8">{{
                model.collection
              }}</label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">filter</label>
              <label class="col-form-label col-lg-8">{{ model.filter }}</label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">projection</label>
              <label class="col-form-label col-lg-8">{{
                model.projection
              }}</label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">สถานะ</label>
              <label class="col-form-label col-lg-8"
                ><span
                  class="label"
                  :class="'label-' + model.status.toLowerCase()"
                  v-html="model.status"
                ></span
              ></label>
            </div>
            <div class="form-group mb-4 text-left">
              <div class="button-items">
                <button type="button" class="btn btn-light" @click="onCancel()">
                  <i
                    class="bx bx-arrow-back font-size-16 align-middle mr-2"
                  ></i>
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import attributeSkuMechanicService from '@/helpers/service/attribute-sku-mechanic-service'
import { eventBus } from '@/main.js'
import { StatusEnum } from '@/enum/status.enum.js'
import { BasicSelect } from 'vue-search-select'
import { OptionDropdownStatus } from '@/helpers/utils/status.js'
import Switches from 'vue-switches'
/**
 * Projects-create component
 */
export default {
  page: {
    title: 'Attribute Sku Mechanic',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    PageHeader,
    Switches,
    'basic-select': BasicSelect,
  },
  data() {
    return {
      id: '',
      title: 'View',
      mode: 'view',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Attribute Sku Mechanic',
          href: '/attribute-sku-mechanics',
        },
        {
          text: 'View',
          active: true,
        },
      ],
      reloadTypeSelector: false,
      optionsType: [
        { text: 'Database', value: 'Database_value' },
        { text: 'FreeText', value: 'FreeText_value' },
      ],
      model: {
        id: null,
        display_name: {
          th: '',
          en: '',
        },
        type: '',
        collection: '',
        filter: '',
        projection: '',
        is_default_attribute: true,
        status: StatusEnum.ACTIVE,
        create_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
        update_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
      },
      isValidate: {
        display_name_th: false,
        display_name_en: false,
        status: false,
      },
      reloadStatusSelector: false,
      optionsStatus: [],
    }
  },
  created() {
    if (this.$route.params.id == 'new') {
      this.mode = 'new'
      this.title = 'New Attribute Sku Mechanic'
      this.items[2].text = 'New'

      setTimeout(() => {
        document.title = `New Attribute Sku Mechanic | ${appConfig.description}`
      }, 100)
    } else {
      this.title = 'Detail'
      this.items[2].text = 'Detail'
      this.id = this.$route.params.id

      setTimeout(() => {
        document.title = `Edit Attribute Sku Mechanic | ${appConfig.description}`
      }, 100)
    }
    if (this.$route.query.mode) {
      this.title = 'Edit Attribute Sku Mechanic'
      this.items[2].text = 'Edit'
      this.mode = this.$route.query.mode
    }
  },
  mounted() {
    this.optionsStatus = OptionDropdownStatus
    if (this.mode !== 'new') {
      this.getDetail()
    }
  },
  methods: {
    async getDetail() {
      let result = await attributeSkuMechanicService.getAttributeSkuMechanicMasterDetailAsync(
        this.id
      )
      if (result.status === 200) {
        this.model = result.data
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    onCancel() {
      this.$router.push({
        path: '/attribute-sku-mechanics',
      })
    },
    async onConfirmReset() {
      await this.$utils
        .confirmAlertDisplay(
          `ต้องการ Reset หน้าจอเป็นค่าเริ่มต้นใช่หรือไม่`,
          ''
        )
        .then(result => {
          if (result) {
            if (this.mode === 'new') {
              this.reloadTypeSelector = true
              this.model.display_name.en = ''
              this.model.display_name.th = ''
              this.model.status = StatusEnum.ACTIVE
              this.model.type = ''
              this.model.collection = ''
              this.model.filter = ''
              this.model.projection = ''
              this.model.is_default_attribute = true
            } else {
              this.getDetail()
            }
          }
        })
    },
    async onSubmit() {
      if (
        this.model.status === '' ||
        this.model.status === undefined ||
        this.model.status === null
      ) {
        this.isValidate.status = true
        return
      }
      if (this.mode === 'new') {
        await this.onSaveCreate()
      } else {
        await this.onSave()
      }
    },
    changeMode(_mode) {
      if (_mode == 'edit') {
        this.mode = 'edit'
        this.title = 'Edit'
        this.items[2].text = 'Edit'
        this.getDetail()
      }
    },
    async onSave() {
      this.$refs.addDataForm.validate().then(async response => {
        if (response) {
          this.removeLastAndFirstSpacesFromString()
          let result = await attributeSkuMechanicService.updateAttributeSkuMechanicMasterAsync(
            this.id,
            this.model
          )
          if (result.status && result.status === 204) {
            this.$utils.notification('success', 'แก้ไขข้อมูลสำเร็จ', 1500)
            this.$router.push({
              path: '/attribute-sku-mechanics',
            })
          } else if (
            (result.status && result.status !== 500) ||
            (result.response && result.response.status !== 500)
          ) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          }
        }
      })
    },
    async onSaveCreate() {
      this.$refs.addDataForm.validate().then(async response => {
        if (response) {
          this.removeLastAndFirstSpacesFromString()
          let result = await attributeSkuMechanicService.createAttributeSkuMechanicMasterAsync(
            this.model
          )
          if (result.status === 201) {
            this.$utils.notification('success', 'เพิ่มข้อมูลสำเร็จ', 1500)
            this.$router.push({
              path: '/attribute-sku-mechanics',
            })
          } else if (
            (result.status && result.status !== 500) ||
            (result.response && result.response.status !== 500)
          ) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          }
        }
      })
    },
    async onValidateDisplaynameTH() {
      if (
        !(
          this.model.display_name.th.trim() === '' ||
          this.model.display_name.th.trim() === null ||
          this.model.display_name.th.trim() === undefined
        )
      ) {
        let params = new URLSearchParams()
        params.append('nameTh', this.model.display_name.th.trim())
        if (this.mode === 'edit') {
          params.append('id', this.id)
        }
        let result = await attributeSkuMechanicService.headAttributeSkuMechanicMasterAsync(
          params
        )
        if (result.status === 200) {
          this.isValidate.display_name_th = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name_th = false
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async onValidateDisplaynameEN() {
      if (
        !(
          this.model.display_name.en.trim() === '' ||
          this.model.display_name.en.trim() === null ||
          this.model.display_name.en.trim() === undefined
        )
      ) {
        let params = new URLSearchParams()
        params.append('nameEn', this.model.display_name.en.trim())
        if (this.mode === 'edit') {
          params.append('id', this.id)
        }
        let result = await attributeSkuMechanicService.headAttributeSkuMechanicMasterAsync(
          params
        )
        if (result.status === 200) {
          this.isValidate.display_name_en = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name_en = false
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    removeLastAndFirstSpacesFromString() {
      this.model.display_name = {
        en: this.model.display_name.en.trim(),
        th: this.model.display_name.th.trim(),
      }
    },
    async onTypeSelector(data) {
      this.reloadTypeSelector = false
      this.model.type = data.text ? data.text : ''
    },
    async onStatusSelector(data) {
      this.isValidate.status = false
      this.reloadStatusSelector = false
      this.model.status = data.text ? data.text : ''
    },
  },
}
</script>
